export const updateContentPosition = (
  e:
    | React.KeyboardEvent<HTMLButtonElement>
    | React.MouseEvent<HTMLButtonElement, MouseEvent>
    | React.TouchEvent<HTMLButtonElement>
) => {
  const target = e.currentTarget || e.target;
  if (!(target instanceof HTMLElement)) {
    return;
  }

  const container = document.getElementById('NavigationRoot');
  if (!container) {
    return;
  }
  const rect = target.getBoundingClientRect();

  const middleX = rect.left + rect.width / 2;

  const containerRect = container.getBoundingClientRect();
  const itemPosition = `${middleX - containerRect.left - 53}px`;

  container.style.setProperty(
    '--radix-navigation-menu-item-active-left',
    itemPosition
  );
};
